exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__SvgIcon__block {\n  display: block;\n}\n\n.DS__SvgIcon__size_auto {\n    width: 100%;\n    height: 100%;\n  }\n\n.DS__SvgIcon__size_sm {\n    width: 12px;\n    height: 12px;\n  }\n\n.DS__SvgIcon__size_md {\n    width: 20px;\n    height: 20px;\n  }\n\n.DS__SvgIcon__size_lg {\n    width: 32px;\n    height: 32px;\n  }\n\n.DS__SvgIcon__size_xl {\n    width: 40px;\n    height: 40px;\n  }\n", ""]);

// exports
exports.locals = {
	"block": "DS__SvgIcon__block",
	"size_auto": "DS__SvgIcon__size_auto",
	"size_sm": "DS__SvgIcon__size_sm",
	"size_md": "DS__SvgIcon__size_md",
	"size_lg": "DS__SvgIcon__size_lg",
	"size_xl": "DS__SvgIcon__size_xl"
};